import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components'

export default class SCheckbox extends PureComponent {
    static propTypes = {
        /**
         * Id чекбокса
         */
        id: PropTypes.string,
        /**
         * Имя чекбокса
         */
        name: PropTypes.string,
        /**
         * Форма чекбокса
         */
        type: PropTypes.oneOf(['rectangle', 'round']),
        /**
         * Значение чекбокса
         */
        checked: PropTypes.bool,
        /**
         * Колбек отрабатывающий при изменении checkbox'a
         * `onCheck(event, checked)`
         * Принимает параметры: DOM-события и флаг включения/отключения чекбокса
         */
        onCheck: PropTypes.func,
        /**
         * Подпись
         */
        label: PropTypes.string,
        /**
         * Расположение чекбокса
         */
        checkboxPosition: PropTypes.oneOf(['left', 'right']),
        /**
         * Размер чекбокса
         */
        size: PropTypes.oneOf(['medium', 'small']),
        /**
         * Стиль чекбокса
         */
        checkboxStyle: PropTypes.object,
        /**
         * Стиль лейбла
         */
        labelStyle: PropTypes.object,
        /**
         * Цвет чекбокса
         */
        color: PropTypes.oneOf(['gray', 'black'])
    };

    static defaultProps = {
        disabled: false,
        checked: false,
        indeterminate: undefined,
        type: 'rectangle',
        checkboxPosition: 'left',
        size: 'medium',
        color: 'black',
    };

    onChange = event => {
        if (this.props.onCheck) this.props.onCheck(event, this.selector.checked)
    }

    componentDidMount() {
        this.selector.indeterminate = this.props.indeterminate;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.indeterminate !== this.props.indeterminate) {
            this.selector.indeterminate = this.props.indeterminate;
        }
    }

    render() {
        const {
            id,
            label,
            type,
            size,
            indeterminate,
            checkboxPosition,
            onCheck,
            checkboxStyle,
            labelStyle,
            color,
            labelTheme,
            ...inputProps
        } = this.props;

        const checkboxClassname = `
          s-checkbox
          ${checkboxPosition === 'right' && 's-checkbox__right'}
          ${type === 'round' && 's-checkbox__round'}
        `;

        const inputClassname = `
          s-checkbox__input
          ${size === 'small' && 's-checkbox__input_small'}
          ${color}
          ${checkboxPosition === 'right' && 's-checkbox__right_input'}
          ${type === 'round' && 's-checkbox__round_input'}
        `;

        const labelClassname = `
          s-checkbox__label
          ${labelTheme && `${labelTheme}`}
        `;

        return (
            <div className={checkboxClassname}>
                <input
                    type="checkbox"
                    className={inputClassname}
                    ref={el => (this.selector = el)}
                    id={id}
                    onChange={this.onChange}
                    style={checkboxStyle}
                    {...inputProps}
                />
                <label
                    className={labelClassname}
                    htmlFor={id}
                    style={labelStyle}
                >
                    {label}
                </label>
            </div>
        )
    }
}
